import React from 'react'

const LocalSecurity = () => {
  return (
    <div>LocalSecurity</div>
  )
}

export default LocalSecurity